import { connect } from 'react-redux';
import KlentyView from './KlentyView.jsx';
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'klenty');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    error: state.legacyRootReducer.settings.integrations.klenty.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
  }
  }
}

const KlentyPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(KlentyView);

export default withUseHooks(KlentyPage);